import {
  $getRoot,
  $isElementNode,
  $isTextNode,
  EditorState,
  ElementNode,
  LexicalEditor,
} from "lexical";
import { isVariableNode } from "../plugins/VariablesPlugin/utils";

export function $validateEditorState(input: LexicalEditor | EditorState) {
  const editorState =
    "getEditorState" in input ? input.getEditorState() : input;

  return editorState.read(() => {
    return validateElementNode($getRoot());
  });
}

function validateElementNode(elemNode: ElementNode): boolean {
  for (const child of elemNode.getChildren()) {
    if (isVariableNode(child)) {
      if (!child.isValid()) {
        return false;
      }
      const previousSibling = child.getPreviousSibling();
      if (
        previousSibling &&
        $isTextNode(previousSibling) &&
        previousSibling.getTextContent().endsWith("{")
      ) {
        return false;
      }
      const nextSibling = child.getNextSibling();
      if (
        nextSibling &&
        $isTextNode(nextSibling) &&
        nextSibling.getTextContent().startsWith("}")
      ) {
        return false;
      }
    } else if ($isElementNode(child)) {
      if (!validateElementNode(child)) {
        return false;
      }
    }
  }
  return true;
}
